import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

import ProductSaleProductsTable from './tables/product-sale-table';

export default function ProductCard() {
  const { t } = useTranslation();

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <Text variant="HeadingXSmall">{t('common:product_details')}</Text>
      <Separator gap={16} />
      <ProductSaleProductsTable />
      <Separator gap={16} />
    </CardSection>
  );
}
